import { useCallback, useEffect, useRef } from 'react';
/* eslint-enable no-undef */
export function useListeners() {
    var globalListeners = useRef(new Map());
    var addListener = useCallback(function (eventTarget, type, listener, options) {
        globalListeners.current.set(listener, { type: type, eventTarget: eventTarget, options: options });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    var removeListener = useCallback(function (eventTarget, type, listener, options) {
        eventTarget.removeEventListener(type, listener, options);
        globalListeners.current.delete(listener);
    }, []);
    var removeAllListeners = useCallback(function () {
        globalListeners.current.forEach(function (value, key) {
            removeListener(value.eventTarget, value.type, key, value.options);
        });
    }, [removeListener]);
    useEffect(function () {
        return removeAllListeners;
    }, [removeAllListeners]);
    return { addListener: addListener, removeListener: removeListener, removeAllListeners: removeAllListeners };
}
